import { render, staticRenderFns } from "./BlockWrapper.vue?vue&type=template&id=9b39b89a"
import script from "./BlockWrapper.vue?vue&type=script&lang=js"
export * from "./BlockWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports